module.exports = __webpack_public_path__ + "static/media/matthew-henry-VviFtDJakYk-unsplash.ff940a3c.jpg";